var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-darkgreen relative flex flex-col items-center justify-center text-center bg-white lg:px-12 md:px-12 py-20"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"w-full mr-auto"},[_c('logo')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }